<template>
	<div id="HomeSearchEmployee" class="front-page-searcher">
        <section class="search-home" v-bind:class="{ 'open block--dark': searchActive }">

            <div @click="OpenSearch" class="search-inputs">

                <div class="loupe">
                    <svg v-if="!searchActive"  width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Forside" transform="translate(-129.000000, -591.000000)" stroke="#343638" stroke-width="2">
                                <g id="Filter-employee" transform="translate(100.000000, 570.000000)">
                                    <g id="Search" transform="translate(30.000000, 19.000000)">
                                        <g id="Icon:-Search" transform="translate(0.000000, 3.000000)">
                                            <path d="M13.5,13.5 L19.5,19.5" id="Line" fill="#343638" stroke-linecap="square"></path>
                                            <circle id="Oval" cx="7.5" cy="7.5" r="7.5"></circle>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                    <svg v-if="searchActive"  width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Forside-med-søk" transform="translate(-129.000000, -591.000000)" stroke-width="2" stroke="#FFFFFF">
                                <g id="Filter-employee" transform="translate(100.000000, 570.000000)">
                                    <g id="Search" transform="translate(30.000000, 19.000000)">
                                        <g id="Icon:-Search">
                                            <g transform="translate(0.000000, 3.000000)">
                                                <path d="M13.5,13.5 L19.5,19.5" id="Line" fill="#343638" stroke-linecap="square"></path>
                                                <circle id="Oval" cx="7.5" cy="7.5" r="7.5"></circle>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>

                <input  class="search-input" v-model="searchName" @focus="onInputFocus" :placeholder="inputPlaceholder"></input>
                <catdropdown v-if="role" :dataList="role" :selection.sync="currentRole" ></catdropdown>
                <catdropdown v-if="categoried" :dataList="categoried" :selection.sync="currentCategory" ></catdropdown>
            </div>

            <div v-if="searchActive" class="search-container" v-bind:class="{ 'no-results' : filteredList.length == 0 }">
                <div class="message message--info" v-if="userErrorInfo">{{userErrorInfo}}</div>

                <div class="message message--info" v-if="(!filteredList[0] && (searchName /*|| currentCategory*/))">{{no_found_text}}</div>

                <!--<ul v-if="(employees && !filteredList[0] && !currentCategory && !searchName)" class="page-employees-rel clearfix">
                    <li class=" " v-for="(employee, key) in employees" :key="employee.id">
                        <singleemployee :postdata="employee"></singleemployee>
                    </li>
                </ul>-->
                <ul v-if="(filteredList[0])" class="page-employees-rel clearfix">
                    <li class="equal-boy" v-for="(employee, key) in filteredList" :key="employee.id">
                        <singleemployee class="" :postdata="employee"></singleemployee>
                    </li>
                </ul>

                <preloader class="posts-preload" v-if="loadingPosts"></preloader>
            </div>
        </section>
	</div>
</template>

<script>
    import preloader from './components/preloader.vue';

    import catDropdown from './components/categoryList.vue';
    import singleEmploye from './components/singleEmploye.vue';
    import axios from 'axios';
    import _orderby from 'lodash.orderby';
   // import matchHeight from 'equal-height';

export default {
    name: 'HomeSearchEmployee',
    components: {
         'preloader' : preloader,
         'catdropdown' : catDropdown,
         'singleemployee' : singleEmploye,
	},
	data () {
		return {
            inputPlaceholder: theme_data.strings.search_placeholder_home,
            no_found_text: theme_data.strings.no_found,
            searchName: '',
            searchActive: false,
            loadingPosts: false,
            userErrorInfo: false,
            currentCategory: 0,
            currentRole: 0,
            employees: [],
            info: null,
            filteredList: [],
            categoried: [
                {
                    'name' : theme_data.strings.loading,
                    'id' : 0,
                    'selected' : true,
                },
            ],
            role: [
                {
                    'name' : theme_data.strings.loading,
                    'id' : 0,
                    'selected' : true,
                },
            ]
		}
    },
    computed: {
/*         filteredList(){
            if(this.employees[0]){
              return this.employees;
            }else{
                return null;
            }
        } */
    },
    watch: {
        currentCategory: function (val) {
            //this.searchEmployee(this.searchName.toLowerCase(), parseInt(this.currentCategory));
            let mar = this.categoried.filter( (cat)=> {
                if(cat.paged_id && cat.id === parseInt(this.currentCategory) ){
                    return cat.paged_url;
                }
            });
            if(mar[0] && mar[0].paged_url) window.location.href = mar[0].paged_url;

        },
        currentRole: function (val) {
            this.searchEmployee(this.searchName.toLowerCase(), parseInt(this.currentRole));
        },
        searchName: function (val) {
            this.searchEmployee(this.searchName.toLowerCase(), this.currentRole);
        },
    },//762
	methods: {
        onInputFocus() {
            setTimeout(function() {
                jQuery('html,body').animate({ scrollTop: jQuery('#HomeSearchEmployee').offset().top - 50 }, 500);
            }, 100);
		},
        searchEmployee(searchText, filterCat){
            this.filteredList = this.employees.filter(function (employee) {
                if( employee.role && filterCat){
                   return employee.role.filter(function (posit) {
                        if(posit.term_id === filterCat){
                            return posit;
                        }
                    }).length;

                }
                if( searchText != ''){
                    if( employee.first_name.toLowerCase().indexOf( searchText ) !== -1 ){
                        return employee  ;
                    }
                    if( employee.main_position.toLowerCase().indexOf( searchText ) !== -1 ){
                        return employee  ;
                    }
                    if( employee.lastname.toLowerCase().indexOf( searchText ) !== -1 ){
                        return employee  ;
                    }
                }
                return false;
            });
        },
        closeBlockSearch: function () {
            this.searchActive = false;
        },
        OpenSearch(){
            this.searchActive = true;
        },

        apiGetData(){
            const self = this;
            axios.get( theme_data.api+'bahr/v2/load_employees_cq/', {
                    params: {
                        lang: theme_data.language,
                    }
            })
            .then(function (response) {
                if(response.data.posts_data){
                    self.userErrorInfo = false;

                    //self.employees = self.employees.concat(response.data.posts_data);
                    self.employees = response.data.posts_data;
                    self.filteredList  = response.data.posts_data;
                    self.employees = _orderby(self.employees, ['first_name'], ['asc']);
                    self.filteredList = _orderby(self.filteredList, ['first_name'], ['asc']);
                    self.saveLocalForge(self.employees, response.data.cache_ver).then( (vale) => {
                         // console.log('update store', vale);
                     });
                    self.loadingPosts = false;

                }else{
                    self.userErrorInfo = theme_data.strings.nothing_to_show;
                }
            })
            .catch(function (error) {
                    self.info = 'Error! Could not reach the API. ' + error
            })
        },
        loadData: function(){
            const self = this;
            const cacheServer = theme_data.employee_versions;

            self.loadingPosts = true;
            self.loadLocalStorage().then( (storageData) => {
                if(storageData && storageData.version === cacheServer){
                    self.employees = storageData.employees;
                    self.filteredList  = storageData.employees;
                    self.loadingPosts = false;
                }else{
                     self.apiGetData()
                }
            })
        },
        loadPositions(){
            var self = this;
            axios.get( theme_data.api+'bahr/v2/positions/', {
                    params: {
                        lang: theme_data.language,
                        hide_empty: 1,
                        nocache: new Date().getTime()
                    }
            })
            .then(function (response) {
                //self.info = response.data.speclaisation;
                let categoried = [
                    {
                        'name' : theme_data.strings.specialization_placeholder,
                        'id' : 0,
                        'selected' : true,
                    }
                ];
                let role = [
                    {
                        'name' : theme_data.strings.role_placeholder,
                        'id' : 0,
                        'selected' : true,
                    }
                ];
                //console.log(response.data);
                response.data.speclaisation = _orderby(response.data.speclaisation, ['name'], ['asc']);
                response.data.role = _orderby(response.data.role, [ 'term_order'], ['asc']);

                self.role = role.concat(response.data.role);
                self.categoried = categoried.concat(response.data.speclaisation);
            })
            .catch(function (error) {
                    self.info = 'Error! Could not reach the API. ' + error
            });
        }

    },
    mounted: function(){
        const self = this;

        if( !self.searchActive){
            jQuery(document).ready(function ($) {
                $(window).keydown(function(evt) {
                    if (evt.which == 27) {
                        self.closeBlockSearch();
                    }
                });
                $(document).click(function(e){
                    let container = $('#HomeSearchEmployee');
                    if (!container.is(e.target) && container.has(e.target).length === 0)
                    {
                        self.closeBlockSearch();
                    }
                })
            });
        }

        self.loadData();
        self.loadPositions();
/*         if (typeof(Storage) !== "undefined") {

            console.log( 'load from storage' );
            let listStroaged = localStorage.getItem('employeeList');
            if(listStroaged){
                self.employees = JSON.parse(listStroaged);
            }else{
                self.loadData()
            }
        } else {
            self.loadData();
        } */

    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue/HomeSearchEmployee.vue?4818853c